import type * as Sentry from '@sentry/react';

const SENSITIVE_HEADERS = ['authorization', 'cookie', 'set-cookie'];

export function scrubSensitiveData(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  if (event.request?.headers) {
    event.request.headers = Object.fromEntries(
      Object.entries(event.request.headers).filter(
        ([key]) => !SENSITIVE_HEADERS.includes(key.toLowerCase()),
      ),
    );
  }
  if (event.contexts?.state) {
    const { state: _dropped, ...contexts } = event.contexts;
    event.contexts = contexts;
  }
  if (event.breadcrumbs) {
    for (const crumb of event.breadcrumbs) {
      if ((crumb.category === 'fetch' || crumb.category === 'xhr') && crumb.data) {
        crumb.data = Object.fromEntries(
          Object.entries(crumb.data).filter(
            ([key]) => key !== 'request_headers' && key !== 'response_headers',
          ),
        );
      }
      if (crumb.category === 'redux.action' && crumb.data) {
        crumb.data = { type: crumb.data['type'] };
      }
    }
  }
  return event;
}
